import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import PhotosCard from '../../cards/PhotosCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const PhotosCardWidget = (props) => {
    const component = useMemo(() => (_jsx(_Fragment, { children: props.user && (_jsx(PhotosCard, { actions: [], matchedPrimary: props.user, viewDefinition: {}, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions })) })), [props.user]);
    return {
        name: 'PhotosCard',
        category: 'composite',
        component,
    };
};
